import {
  Container, Box, Grid, Button
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useStyles } from './style';

export const CardVerifyPhotos = () => {
  const classes = useStyles();
  const history = useHistory();
  const frontCardPhoto = useSelector((state) => state.camera.frontCardImage);
  const backCardPhoto = useSelector((state) => state.camera.backCardImage);
  const profile = useSelector((state) => state.profile.profilInfo);
  const profileFrontCard = profile.InsuranceCardPhotoFront && `data:image/jpeg;base64,${profile.InsuranceCardPhotoFront}`;
  const profileBackCard = profile.InsuranceCardPhotoBack && `data:image/jpeg;base64,${profile.InsuranceCardPhotoBack}`;

  const onRetakeHandler = () => {
    history.push('/card-view');
  };

  const onSubmitHandler = () => {
    history.push('/download-guide');
  };

  return (
    <Container maxWidth="md" className={classes.mainContainer}>
      <Box className={classes.root}>
        <Grid container>
          <Grid item xs={12} md={12} className={classes.gridItem}>
            <Box className={classes.title}>Verify Photos</Box>
          </Grid>
          <Grid item xs={12} md={6} className={classes.gridItem}>
            <Box className={classes.photoTitle}>Front</Box>
            <Box component="img" src={profileFrontCard || frontCardPhoto} className={classes.photo} />
          </Grid>
          <Grid item xs={12} md={6} className={classes.gridItem}>
            <Box className={classes.photoTitle}>Back</Box>
            <Box component="img" src={profileBackCard || backCardPhoto} className={classes.photo} />
          </Grid>
          <Grid item xs={12} md={6} className={classes.primaryBtnWrapper}>
            <Box px={2}>
              <Button onClick={onSubmitHandler} variant="contained" color="primary">
                Submit
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} className={classes.secondaryBtnWrapper}>
            <Box px={2}>
              <Button variant="contained" color="secondary" onClick={onRetakeHandler}>
                Retake
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
